<template>

    <div class="admin-help">

        <b-card no-body class="mb-4"
                v-for="i in stepIndices">
            <b-card-header>
                <strong>Step {{ i }}:</strong> {{ stepTitle(i) }}
            </b-card-header>
            <b-card-body>
                <VueTrix v-model="help[`step${i}`]" placeholder="Enter help text"/>
            </b-card-body>
        </b-card>

    </div>

</template>

<script>

    import Vue from 'vue'
    import VueTrix from "vue-trix";

    export default Vue.extend({
        name: 'AdminHelp',
        components: {
            VueTrix
        },
        props: {
            toolName: String
        },
        computed: {
            config() {
                return this.$store.state.config
            },
            stepIndices() {
                return _.range(1, this.$api.TOOLS[this.toolName].options.steps.length + 1)
            },
            help() {
                if (this.config[this.toolName]) {
                    return this.config[this.toolName].help
                } else {
                    return {}
                }
            }
        },
        methods: {
            stepTitle(i) {
                const step = _.find(this.$api.TOOLS[this.toolName].options.steps, (step) => step.id == i)
                return step.title
            },
        }
    })
</script>

<style lang="scss">

    .admin-help {
        .trix-button-group--file-tools {
            display: none;
        }
    }

</style>
